export const salesPageContent = {
  brand: 'Quotidien TDAH',
  supportEmail: 'contact@quotidientdah.eu',
  oldPrice: '14,90 €',
  launchPrice: '9,90 €',
  stickyCta: {
    label: 'Débloquer l’ebook',
    price: '9,90 €',
  },
  hero: {
    title: 'Environ 4 adultes sur 5 concernés par le TDAH ne le savent pas encore.',
    body: 'Tu fais peut-être partie des personnes qui ont appris à compenser, à faire bonne figure et à culpabiliser… sans comprendre pourquoi certaines choses ordinaires leur demandent autant d’effort.',
  },
  opening: {
    title: 'Tu sembles gérer. Alors pourquoi tout te demande autant d’énergie ?',
    paragraphs: [
      'De l’extérieur, tu avances.',
      'Tu travailles, tu réponds aux autres et tu assumes tes responsabilités.',
      'Mais personne ne voit nécessairement les listes que tu recommences, les alarmes pour ne rien oublier ou la pression de dernière minute dont tu as besoin pour enfin agir.',
      'Certains jours, tu peux accomplir énormément.',
      'D’autres fois, une tâche de cinq minutes semble impossible à commencer.',
      'Et lorsque tu bloques encore, tu finis peut-être par penser que tu manques simplement de discipline, d’organisation ou de volonté.',
      'Puis tu découvres le TDAH.',
      'Une vidéo, un témoignage ou une publication décrit ton quotidien avec une précision troublante.',
      'Pour la première fois, certaines choses semblent avoir un sens.',
      'Mais très vite, une nouvelle question apparaît :',
    ],
    question: '« Je me reconnais dans le TDAH… et maintenant ? »',
  },
  recognition: {
    paragraphs: [
      'Se reconnaître dans certains témoignages peut être un point de départ.',
      'Mais entre les listes de « signes cachés », les expériences personnelles et les informations contradictoires, il devient difficile de savoir ce qui est réellement important.',
      'Un jour, tu penses avoir enfin trouvé une explication.',
      'Le lendemain, tu te demandes si tu ne t’es pas simplement laissé influencer.',
    ],
  },
  guide: {
    title: 'Un guide pour sortir du flou',
    paragraphs: [
      'Après avoir lu des centaines de commentaires de personnes qui se reconnaissaient dans le TDAH sans savoir quoi faire ensuite, j’ai compris qu’il ne manquait pas forcément d’informations.',
      'Il manquait surtout un chemin clair pour les comprendre.',
      'J’ai donc créé cet ebook pour t’aider à passer de :',
    ],
    before: '« Je me reconnais partout, mais je ne sais plus quoi penser »',
    after: '« Je comprends mieux ce que j’observe et je sais quelles étapes envisager. »',
  },
  benefits: {
    title: 'Concrètement, cet ebook va t’aider à…',
    items: [
      'comprendre ce qui caractérise réellement le TDAH chez l’adulte, au-delà des clichés diffusés sur les réseaux ;',
      'repérer les situations et les difficultés qu’il peut être utile de noter dans ton quotidien ;',
      'comprendre pourquoi un comportement isolé ne suffit pas et quels éléments lui donnent réellement du contexte ;',
      'savoir vers quels professionnels te tourner et comment se déroule une démarche diagnostique ;',
      'préparer une éventuelle consultation avec des observations structurées plutôt qu’avec des dizaines de vidéos enregistrées ;',
      'mieux comprendre les étapes qui peuvent suivre un questionnement ou un diagnostic.',
    ],
    closing: [
      'Tu ne termineras pas cette lecture avec une étiquette attribuée par un PDF.',
      'Tu la termineras avec des repères plus solides, de meilleures questions et une vision plus claire de la suite.',
    ],
  },
  reading: {
    title: 'Un ebook pensé pour être parcouru à ton rythme',
    countPlaceholder: '111 pages et 7 chapitres',
    paragraphs: [
      'Tu n’as pas besoin de tout lire en une fois.',
      'Les chapitres peuvent être parcourus séparément. Tu peux avancer quelques pages à la fois, t’arrêter, puis revenir facilement aux explications, aux synthèses ou aux exercices dont tu as besoin.',
    ],
    previews: [
      {
        title: 'Page explicative',
        expectedAsset: 'ebook/evidence.webp',
        alt: 'Aperçu d’une page explicative de l’ebook sur les niveaux de preuve',
      },
      {
        title: 'Synthèse',
        expectedAsset: 'ebook/preview-tools.webp',
        alt: 'Aperçu d’une synthèse de l’ebook sur les quatre outils d’orientation',
      },
      {
        title: 'Exercice',
        expectedAsset: 'ebook/preview-exercise.webp',
        alt: 'Aperçu d’un exercice de l’ebook à compléter',
      },
    ],
  },
  freeInfo: {
    title: 'Pourquoi payer alors que l’information existe gratuitement ?',
    paragraphs: [
      'Parce que le problème n’est pas toujours le manque d’informations.',
      'C’est souvent leur dispersion.',
      'Une vidéo parle de procrastination. Une autre de surcharge. Un témoignage te correspond parfaitement, puis une publication affirme presque le contraire.',
      'Cet ebook rassemble les informations essentielles dans un parcours cohérent que tu peux conserver, annoter et consulter à ton rythme.',
      'Tu n’achètes pas une nouvelle liste de symptômes.',
      'Tu achètes un chemin structuré pour comprendre ce que tu reconnais et savoir quoi faire de cette information.',
    ],
  },
  fit: {
    title: 'Tu n’as pas besoin d’être déjà sûr de toi',
    paragraphs: [
      'Cet ebook est fait pour toi si tu te reconnais dans le TDAH, si tu envisages une démarche professionnelle ou si tu as déjà reçu un diagnostic sans encore comprendre tout ce qu’il implique.',
      'Il ne conclura pas à ta place et ne remplacera jamais un professionnel.',
      'Il t’aidera à organiser tes observations, à comprendre cette piste plus sérieusement et à décider plus sereinement de la suite — même si une autre explication correspond finalement mieux à ce que tu vis.',
      'L’objectif n’est pas d’obtenir une étiquette à tout prix.',
    ],
    quote: 'L’objectif est de mieux comprendre ce que tu vis.',
  },
  offer: {
    eyebrow: 'Offre de lancement',
    title: 'Reçois immédiatement l’ebook complet',
    subtitle: '« Je me reconnais dans le TDAH… et maintenant ? »',
    bullets: [
      'Ebook complet au format PDF',
      'Lecture sur téléphone, tablette ou ordinateur',
      'Explications, synthèses et exercices',
      'Livraison immédiate par email',
      'Lien de téléchargement valable 30 jours',
      'Assistance par email en cas de problème',
    ],
    paymentLine: 'Paiement unique. Aucun abonnement.',
    securityLine: 'Paiement sécurisé · Livraison immédiate par email',
    cta: 'Obtenir mon ebook — 9,90 €',
  },
  footer: {
    disclaimer: 'Cet ebook fournit un contenu informatif et éducatif. Il ne remplace pas l’évaluation, le diagnostic ou l’accompagnement d’un professionnel qualifié.',
    links: [
      { label: 'Mentions légales', href: '/mentions-legales' },
      { label: 'Politique de confidentialité', href: '/politique-confidentialite' },
      { label: 'Conditions de vente', href: '/conditions-de-vente' },
    ],
  },
};
